import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export default function BuyPoints({ showBuyPointsmodal, toggleBuyPoints, isUserLoggedIn, setBuyPointsmodal }) {
    const navigate = useNavigate();

    const handleClick = () => navigate('/sign-in');
    const handleClose = () => setBuyPointsmodal(false);

    return (
        <>
            <Modal className='addnew_route modal-dialog-centered' isOpen={showBuyPointsmodal} toggle={toggleBuyPoints}>
                <ModalHeader toggle={toggleBuyPoints}>
                </ModalHeader>
                <ModalBody>
                    {isUserLoggedIn ?
                        <h5 className='text-center'>Coming soon..</h5>
                        :
                        <p className='text-center'>Please login to continue.</p>
                    }
                </ModalBody>
                {!isUserLoggedIn &&
                    <ModalFooter>
                        <Button type='button' color="primary" onClick={handleClick}>Ok</Button>
                        <Button type='button' color="primary" onClick={handleClose}>Cancel</Button>
                    </ModalFooter>
                }
            </Modal>
        </>
    )
}
